import ButtonExportExcel from '../../../../components/ui/ButtonExportExcel'
import { exportExcelBook } from '../../../../service/ExportExcelBook'
import { useParseQuery } from '../../../../hooks/useNav'

export default function ExportExcelBook() {
  const { queryParams } = useParseQuery()
  const pageNumber = parseInt(queryParams?.pageNumber - 1) || 0

  const handleClick = async () => {
    try {
      const res = await exportExcelBook.export({
        ...queryParams,
        pageNumber,
      })

      if (!res.ok) {
        console.error('Export failed:', res.status, res.statusText)
        return
      }

      const blob = await res.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      const now = new Date()

      const day = String(now.getDate()).padStart(2, '0')
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const year = now.getFullYear()
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')

      const formatted = `${day}${month}${year}${hours}${minutes}${seconds}`

      a.download = `books_${formatted}.xlsx`
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Error when exporting excel:', error)
    }
  }

  return <ButtonExportExcel onClick={handleClick} />
}
